import { default as InfoIcon } from '../components/Info1';

export default InfoIcon;
